// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__qGReH","tabsBox":"styles_tabsBox__xKI_g","createButton":"styles_createButton__3UGIz"};